/**
  * 约看 接口的统一出口
  */
import axios from '.././http' // 导入http中创建的axios实例
import qs from 'qs' // 根据需求是否导入qs模块，把请求字段直接映射过来

// 接口请求地址
const api = '/c-api/'

const lives = {
  // 列表
  list(params) {
    return axios.get(api + 'lives/list', { params: params })
  },
  // 详情
  detail(params) {
    return axios.get(api + 'lives/detail', { params: params })
  },
  // 审核
  status(params) {
    return axios.post(api + 'lives/status', qs.stringify(params))
  },
  // 删除
  remove(params) {
    return axios.post(api + 'lives/remove', qs.stringify(params))
  },
  //批量增加场次
  fieldsbatch(params) {
    return axios.post(api + 'lives/fieldsbatch', qs.stringify(params))
  },

}

// 导出接口
export default lives
